import React, { useMemo } from 'react';
import { FormattedVesselsMovementData } from '@/modules/Vessel/types';
import { dateConverter, getDocumentManagementPath } from '@/utils/helpers';
import { Link } from 'react-router-dom';
import {
  Icon,
  faEye,
  faUpload,
  CustomColumns,
  CustomTable,
} from '@/ui/components';
import { AppEntities } from '@/types';

import { AppRoutes } from '@/routes';
import { useAppCustomers } from '@/hooks';
import { VesselDataGridInner } from './VesselDataGridInner';
import { Space } from 'antd';

type VesselDataGridProps = {
  dataSource: FormattedVesselsMovementData[];
  onSelectVesselGroup: (mmsi: number | null) => void;
};

export const VesselDataGrid = ({
  dataSource,
  onSelectVesselGroup,
}: VesselDataGridProps) => {
  const { hasAdminAccess } = useAppCustomers();

  const columns: CustomColumns<FormattedVesselsMovementData> = useMemo(
    () => [
      { dataIndex: 'vessel', title: 'vessel', minWidth: 60, width: 160 },
      {
        dataIndex: 'despatchDate',
        title: 'Despatch Date',
        width: 90,
        render: (value) => dateConverter(value),
      },
      {
        dataIndex: 'etaDate',
        title: 'ETA Date',
        width: 90,
        render: (value) => dateConverter(value),
      },
      { dataIndex: 'locationFrom', title: 'Location From' },
      { dataIndex: 'locationTo', title: 'Location To' },
      { dataIndex: 'quantity', title: 'Quantity' },
      {
        dataIndex: 'vessel',
        width: 80,
        render: (value) => (
          <Space>
            <Link to={AppRoutes.documentManagement}>
              <Icon icon={faEye} />
            </Link>
            {hasAdminAccess && (
              <Link
                to={getDocumentManagementPath({
                  modal: 'uploadDocument',
                  entity: AppEntities.Vessel,
                  entityReference: value,
                })}
                style={{ marginLeft: '8px' }}
              >
                <Icon icon={faUpload} />
              </Link>
            )}
          </Space>
        ),
      },
    ],
    [hasAdminAccess],
  );

  return (
    <CustomTable
      dataSource={dataSource}
      columns={columns}
      rowKey="vesselId"
      exportOptions={{ fileName: 'Vessel' }}
      expandable={{
        onExpand: (expanded, record) => {
          onSelectVesselGroup(expanded ? record.mmsi : null);
        },
        expandedRowRender: (data) => (
          <VesselDataGridInner dataSource={data.items} />
        ),
      }}
      scroll={{ x: true }}
    />
  );
};
